import TextUsModal from './TextUsModal';
export default TextUsModal;
